import React from "react";

import ReactDOM from "react-dom/client";

import App from "~/App.tsx";
import "~/index.css";
import { installDomTranslationGuard } from "~/lib/domTranslationGuard.ts";
import { initSentry } from "~/lib/sentry.ts";

// Harden the DOM against browser auto-translation (Google Translate) crashing
// React — must run before the first render. See domTranslationGuard for details.
installDomTranslationGuard();

// Initialize Sentry
initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
